var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.63636 15.4545H5.56818V14.1875C7.95455 14.0227 9.29545 12.6136 9.29545 10.8409C9.29545 8.65909 7.22727 7.95455 6.02273 7.63636L5.56818 7.51136V3.47159C6.77273 3.59091 7.64773 4.23864 7.77273 5.27273H9.13636C9.07955 3.61364 7.625 2.35227 5.56818 2.21591V0.90909H4.63636V2.23295C2.6875 2.43182 1.22727 3.67045 1.22727 5.45455C1.22727 7.02273 2.36364 7.95455 4.18182 8.47727L4.63636 8.60795V12.9091C3.44318 12.7841 2.46591 12.1705 2.36364 11H0.909091C1.03977 12.7898 2.40341 14.0398 4.63636 14.1875V15.4545ZM5.56818 12.9091V8.875L5.61364 8.88636C6.84091 9.22727 7.93182 9.65909 7.93182 10.8182C7.93182 11.9602 6.94318 12.7557 5.56818 12.9091ZM4.63636 7.26136C3.77273 7.01705 2.59091 6.53977 2.59091 5.38636C2.59091 4.40341 3.38636 3.65341 4.63636 3.48864V7.26136Z",
    fill: "#81909D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.9fd1c3e5.svg";
export { ForwardRef as ReactComponent };